import { render, staticRenderFns } from "./MktCosts.vue?vue&type=template&id=4c6c32a4&"
import script from "./MktCosts.vue?vue&type=script&lang=ts&"
export * from "./MktCosts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports